export const APPLICATION = 'ACCOUNT_SERVICE'
